import APIService from "./api.service";
import authHeader from './auth-header';
import main from '../store/main';


/**
 * payloadData is the data structure sent to the transcoder 
 * websocketConnection to specify transcoding options.
 * 
 * It contains format, video, audio, and filter options that 
 * configure how the video should be transcoded.
 */
var payloadData = {
    "format": {
        "container": "mp4",
        "clip": false
    },
    "video": {
        "uuid": "",
        "codec": "libx264",
        "preset": "fast",
        "pass": "1",
        "crf": 23,
        "pixel_format": "auto",
        "frame_rate": "auto",
        "speed": "auto",
        "tune": "none",
        "profile": "none",
        "level": "none",
        "faststart": false,
        "size": "source",
        "width": "",
        "height": "",
        "mobile": "true", // leer für false
        "hdready": "true",
        "fullhd": "true",
        "format": "widescreen",
        "aspect": "auto",
        "scaling": "auto",
        "codec_options": "",
        "HLS": "hls",
        "HlsListSize": 10,
        "StrictEnabled": "2",
        "HlsTime": 10,
        "HlsPlaylistType": "vod",
        "hlsKeyPath": "false",
        "hlsKeyInfoFile": "",
        "HlsFlags": "append_list",
        "resolutions": "true",
    },
    "audio": {
        "codec": "aac",
        "channel": "2",
        "quality": "128k",
        "sampleRate": "auto",
        "volume": "100"
    },
    "filter": {
        "deband": false,
        "deshake": false,
        "deflicker": false,
        "dejudder": false,
        "denoise": "none",
        "deinterlace": "none",
        "brightness": "0",
        "contrast": "1",
        "saturation": "0",
        "gamma": "0",
        "acontrast": "33"
    }
};


class transcoderService {
    constructor() {
        this.websocketConnection = null;
        this.component = null;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectDelay = 3000;
        this.heartbeatInterval = null;
        this.intentionallyClosed = false;
    }

    startWebSocket(component) {
        this.component = component;
        this.intentionallyClosed = false;
        this.connect();
    }

    isConnected() {
        return this.websocketConnection?.readyState === WebSocket.OPEN;
    }

    waitForConnection(timeout = 5000) {
        return new Promise((resolve, reject) => {
            if (this.isConnected()) {
                resolve();
                return;
            }

            // Warten auf Verbindung
            const startTime = Date.now();
            const checkInterval = setInterval(() => {
                if (this.isConnected()) {
                    clearInterval(checkInterval);
                    resolve();
                } else if (Date.now() - startTime > timeout) {
                    clearInterval(checkInterval);
                    reject(new Error('WebSocket connection timeout'));
                }
            }, 100);
        });
    }

    connect() {
        const token = JSON.stringify(authHeader('upload_token'));

        // Protokoll anhand der Page ermitteln (wss: bei HTTPS, ws: bei HTTP)
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

        // Socket-Wert aus Config: kann Hostname (Legacy) oder Pfad-Präfix sein
        const configSocket = main.state.config.result.socket || 'encoder';

        let url;
        if (configSocket.includes(':') || configSocket.includes('.')) {
            // Legacy: voller Hostname (z.B. "transcoder:8889" oder "transcoder-beispiel.de")
            url = `${protocol}//${configSocket}/ws`;
        } else {
            // Neu: Pfad-Präfix unter aktueller Domain (z.B. "encoder")
            // → wss://<aktuelle-domain>/encoder/ws
            // → nginx matched location /encoder/ und leitet intern an http://transcoder:8889/ws
            url = `${protocol}//${window.location.host}/${configSocket}/ws`;
        }

        this.websocketConnection = new WebSocket(url);

        this.websocketConnection.onopen = (event) => {
            this.writeToScreen("Connection was established!");
            console.log("Verbindung zum Websocket wurde aufgebaut.")
            this.reconnectAttempts = 0;
            this.startHeartbeat();
        };

        this.websocketConnection.onerror = (event) => {
            this.writeToScreen("WebSocket error - check connection");
            console.error("WebSocket error:", event);
        };

        this.websocketConnection.onclose = (event) => {
            this.writeToScreen("Connection was closed!");
            this.stopHeartbeat();

            // Only attempt reconnection if not intentionally closed
            if (!this.intentionallyClosed && this.reconnectAttempts < this.maxReconnectAttempts) {
                this.reconnectAttempts++;
                this.writeToScreen(
                    `Verbindung verloren. Reconnect-Versuch ${this.reconnectAttempts}/${this.maxReconnectAttempts}...`
                );
                setTimeout(() => this.connect(), this.reconnectDelay);
            } else if (!this.intentionallyClosed) {
                this.writeToScreen('WebSocket-Verbindung fehlgeschlagen. Bitte Seite neu laden.');
            }
        };

        this.websocketConnection.onmessage = (event) => {
            if (this.component && this.component.onWSMessage) {
                this.component.onWSMessage(event);
            }
        };
    }

    startHeartbeat() {
        this.heartbeatInterval = setInterval(() => {
            if (this.websocketConnection && this.websocketConnection.readyState === WebSocket.OPEN) {
                this.websocketConnection.send(JSON.stringify({ type: 'ping' }));
            }
        }, 30000); // Every 30 seconds
    }

    stopHeartbeat() {
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;
        }
    }

    onSubmit(response) {

        const extension = response.title.match(/\.[0-9a-z]+$/i);
        const input = `/var/www/public/files/video_uploads/${response.uuid}/original${extension}`;
        const output = "";

        payloadData.video.uuid = response.uuid;
        const payload = JSON.stringify(payloadData, null, 2);

        console.log('📹 Starting encode for:', response.title);

        let submit = {
            "type": "encode",
            "input": input,
            "output": output,
            "payload": payload
        };

        this.sendMessage(JSON.stringify(submit));
    }

    sendMessage(message) {
        if (this.websocketConnection && this.websocketConnection.readyState === WebSocket.OPEN) {
            this.websocketConnection.send(message);
        } else {
            console.error("WebSocket is not open. Ready state:", this.websocketConnection?.readyState);
        }
    }

    writeToScreen(message) {
        console.log(message);
    }

    stopWebSocket() {
        this.intentionallyClosed = true;
        this.stopHeartbeat();
        if (this.websocketConnection) {
            this.websocketConnection.close();
            this.websocketConnection = null;
        }
    }
}

export default new transcoderService();